import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface F906 {
  f906_01: string;         // 部門代碼 (FK)
  f906_02: string;         // 職稱代碼
  f906_11: number;         // 編制人數
  f906_12: number;         // 實際人數
  f906_91: string;         // 建立人員代號
  f906_92: string | null;  // 建立/修改日期
  f906_93: string;         // 修改人員代號
}

export interface F106 {
  f106_01: string;         // 部門代碼 (PK)
  f106_02: number;         // 單位類別
  f106_11: string;         // 部門名稱
  f106_12: string;         // 部門主管代號
  f106_12a: string;        // 部門主管姓名
  f106_13: string;         // 分機
  f106_16: boolean;        // 是否為舊代號
  f106_17: string;         // 副總代號
  f106_17a: string;        // 副總姓名
  f106_21: number;         // 編制總人數
  f106_22: number;         // 實際總人數
  f106_23: string;         // 備註
  f106_24: string;         // 部門群組
  f106_91: string;         // 建立人員代號
  f106_92: string | null;  // 建立/修改日期
  f106_93: string;         // 修改人員代號
  details?: F906[];        // 職稱編制明細
}

export interface CreateRequest {
  f106_01: string;
  f106_02: number;
  f106_11: string;
  f106_12: string;
  f106_12a: string;
  f106_13: string;
  f106_16: boolean;
  f106_17: string;
  f106_17a: string;
  f106_23: string;
  f106_24: string;
  details: F906[];
}

export interface UpdateRequest {
  f106_02: number;
  f106_11: string;
  f106_12: string;
  f106_12a: string;
  f106_13: string;
  f106_16: boolean;
  f106_17: string;
  f106_17a: string;
  f106_23: string;
  f106_24: string;
  details: F906[];
}

export interface ListResponse {
  data: F106[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const deptStaffingApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/dept-staffing', { params });
    return res.data;
  },

  async get(code: string): Promise<F106> {
    const res = await apiClient.get(`/api/dept-staffing/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F106> {
    const res = await apiClient.post('/api/dept-staffing', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<F106> {
    const res = await apiClient.put(`/api/dept-staffing/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/dept-staffing/${encodeURIComponent(code)}`);
  },
};
